import { IStateManager } from "application";
import { produce } from "immer";

const ImmerImpl: Pick<IStateManager, "produceNewState"> = {
  produceNewState: produce,
};

export { ImmerImpl };
